/** TELA INVESTIMENTO */
import React, { useState, useCallback, useContext, useEffect } from "react";

import {
  Hero,
  Button,
  Back,
  Next,
  LinearGradient,
} from "../../../../components";

import { Container, Section, Buttons, NavigateButtons } from "./styles";
import { DataUserContext, NavigateButtonsContext } from "../..";
import { ThemeContext, DefaultTheme } from "styled-components";
import { sendInvestimentEspecificador, getInvestment } from "../../../../services/data-service/api";
import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";

const Question20: React.FC = () => {
  const { next } = useContext(NavigateButtonsContext);
  const { token } = useContext(DataUserContext);

  const [selectIcon, setSelectIcon] = useState<string>("");

  const [requirementsFulfilled, setRequirementsFulfilled] =
    useState<boolean>(false);

  const [error, setError] = useState<number>(0);
  
  useEffect(() => {
    const isValid = selectIcon !== "";

    if (isValid) {
      setRequirementsFulfilled(true);
    }
  }, [selectIcon]);

  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 20);
  }, []);

  function submit() {
    if (requirementsFulfilled) {
      sendInvestimentEspecificador(selectIcon, token);

      next(21);
    } else setError((prevState) => prevState + 1);
  }

  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);

  useEffect(() => {
    if (_theme.steps){ 
        const attTheme = async () => {
            setTimeout(() => {
              fetchInvestment(token)
            }, 500);
        } 
        attTheme();
    };
  }, [_theme]);

  const fetchInvestment = useCallback(async (token: string) => {
      let investment = await getInvestment(token);
      let valsToShow = _theme.steps.etapa_especificador_comodos.propriedades.conteudo.inputs.filter(item => {
        return investment.indexOf(item.valor) > -1
      })

      var i;
      let returnVal = [];
      returnVal['inival'] = 0;
      returnVal['fimval'] = 0;
      for(i=0; i < valsToShow.length; i++){
        returnVal['inival'] += typeof valsToShow[i].inival !== 'undefined' && valsToShow[i].inival ? parseFloat(valsToShow[i].inival) : 0;
        returnVal['fimval'] += typeof valsToShow[i].fimval !== 'undefined' && valsToShow[i].fimval ? parseFloat(valsToShow[i].fimval) : 0;
      }
      returnVal['mediaval'] = (returnVal['inival'] + returnVal['fimval']) / 2;
      
      _theme.steps.etapa_especificador_investimento.propriedades.conteudo.inputs.map(function(item, index){
        if(index == 0){
            item.valor = 'de-'+returnVal['inival']+'mil-ate'+returnVal['mediaval']+'mil';
            item.texto = 'De R$ '+returnVal['inival']+' mil até R$ '+returnVal['mediaval']+' mil';
        } else if(index == 1){
            item.valor = 'de-'+returnVal['mediaval']+'mil-ate'+returnVal['fimval']+'mil';
            item.texto = 'De R$ '+returnVal['mediaval']+' mil até R$ '+returnVal['fimval']+' mil';
        } else if(index == 2){
            item.valor = 'mais-de-'+returnVal['fimval']+'mil';
            item.texto = 'Acima de R$ '+returnVal['fimval']+' mil';
        } else 
            return false;


        return item
      })
      setTheme(_theme);
    }, []);

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_especificador_investimento.propriedades.imagens.etapa_especificador_investimento_imagemBanner.url"
            )}
            title={can(
              theme,
              "theme.steps.etapa_especificador_investimento.propriedades.banner.subtituloBanner"
            )}
          />

          <Section>
            <p>
              {can(
                theme,
                "theme.steps.etapa_especificador_investimento.propriedades.conteudo.titulo"
              )}
            </p>

            <p>
              {can(
                theme,
                "theme.steps.etapa_especificador_investimento.propriedades.conteudo.subtitulo"
              )}
            </p>

            <Buttons>
              {can(
                theme,
                "theme.steps.etapa_especificador_investimento.propriedades.conteudo.inputs"
              ) &&
                theme.steps.etapa_especificador_investimento.propriedades.conteudo.inputs.map(
                  ({ icone, id, texto, valor }, index) => (
                    <Button
                      key={id}
                      disableOnFocus={selectIcon !== valor}
                      selected={selectIcon === valor}
                      onClick={() => setSelectIcon(valor)}
                      icon={
                        <img
                          src={can(
                            theme,
                            `theme.steps.etapa_especificador_investimento.propriedades.conteudo.inputs[${index}].icone[1]`
                          )}
                          alt=""
                        />
                      }
                      title={texto}
                      small
                      criare
                    />
                  )
                )}
            </Buttons>
          </Section>

          <NavigateButtons>
            <Back criare onClick={() => next(HistoryPages.getLastPage())} />
            <Next criare onClick={submit} animationTrigger={error} />
          </NavigateButtons>

          <LinearGradient />
        </Container>
      )}
    </>
  );
};

export default Question20;
